import { render, staticRenderFns } from "./candidate-filters.vue?vue&type=template&id=1133f42b&"
import script from "./candidate-filters.vue?vue&type=script&lang=js&"
export * from "./candidate-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports